import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getSearch } from '../../templates/templates-selector';

export const TemplateCell = ({ assigned, templateName, id, isClone = false }) => {
  const { path } = useRouteMatch();
  const search = useSelector(getSearch);
  const isDrafts = !!(search && search.drafts);

  return (
    <Wrapper>
      {isClone ? (
        <RouteLink to={`${path}clone/${id}`} style={{ textDecoration: 'underline' }}>
          {templateName}
        </RouteLink>
      ) : (
        <>
          <StatusWrap>
            <Status assigned={assigned} />
          </StatusWrap>
          {isDrafts ? (
            <RouteLink to={`${path}draftdetails/${id}`}>{templateName}</RouteLink>
          ) : (
            <RouteLink to={`${path}details/${id}`}>{templateName}</RouteLink>
          )}
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StatusWrap = styled.div`
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
`;

const Status = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ assigned }) => (assigned ? '#66B06E' : '#ADADAD')};
`;

const RouteLink = styled(Link)`
  font-weight: bold;
`;
